import { FAQS } from "@/lib/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="theme-light relative bg-white py-24 lg:py-24"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#D4A84B]" />
            <span className="es-label text-[#D4A84B]">FAQ</span>
            <span className="h-px w-10 bg-[#D4A84B]" />
          </div>
          <h2 className="font-serif-display text-[#101010] text-4xl sm:text-5xl leading-[1.05] tracking-tight">
            Common questions.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#E5E7EB] last:border-b-0"
            >
              <AccordionTrigger
                className="text-left py-6 text-[#101010] font-serif-display text-lg sm:text-xl hover:no-underline hover:text-[#101010] [&[data-state=open]>svg]:text-[#D4A84B]"
                data-testid={`faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent
                className="text-[#4B5055] text-base leading-relaxed pb-6 pr-6"
                data-testid={`faq-content-${i}`}
              >
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
